var SENTRY_RELEASE;SENTRY_RELEASE={name: "rngs-be-router", version: "1.0.0"};